import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useContext, useEffect, useRef } from "react";
import { MapMarkerNewForm } from "./Map-marker-new-form";
import { NewFeatureListContext } from "./Map-marker-list-wrapper";
import { Feature } from "ol";
import Point from "ol/geom/Point";
import { MAP, MARKER_LAYER } from "../Map-marker";
import { Draw } from "ol/interaction";

export const MapMarkerAddButton = () => {
	const { selectedItem, onSelect, detour } = useContext(NewFeatureListContext);

	//Used for storing original feature
	const savedItem = useRef<Feature>();

	const addNewItem = () => {
		const newFeature = new Feature({
			geometry: new Point([0, 0]),
			new: true,
			DONT_UPDATE: true,
			detour,
		});
		if (detour) {
			newFeature.setProperties({ twoWay: true });
		}
		const source = MARKER_LAYER.getSource()!;
		source.addFeature(newFeature!);
		onSelect(newFeature);
	};

	const finishAdding = () => {
		if (selectedItem?.get("new")) {
			selectedItem.setProperties({ new: false, DONT_UPDATE: true }, true);
		}

		const extent = MARKER_LAYER.getSource()!.getExtent();
		if (!isNaN(extent[0])) {
			MAP.getView().fit(extent, { padding: [50, 50, 50, 50], duration: 500 });
		}

		onSelect(undefined);
		savedItem.current = undefined;
	};

	const cancelAdding = () => {
		if (selectedItem!.get("new")) {
			const source = MARKER_LAYER.getSource()!;
			source.removeFeature(selectedItem!);
		}
		if (savedItem.current) {
			const props = selectedItem!.getProperties();
			const ogProps = savedItem.current.getProperties();

			for (const key in props) {
				if (Object.prototype.hasOwnProperty.call(props, key)) {
					props[key] = ogProps[key];
				}
			}

			selectedItem!.setProperties(props);
			savedItem.current = undefined;
		}
		onSelect(undefined);
	};

	useEffect(() => {
		if (!savedItem.current && selectedItem) {
			savedItem.current = selectedItem.clone();
		}
		MAP.getInteractions().forEach((i) => {
			if (i instanceof Draw) i.setActive(false);
		});
	}, [selectedItem]);

	return (
		<div>
			{selectedItem && (
				<div className="fixed top-0 left-0 bottom-0 right-0 z-50 bg-black/40 flex flex-col justify-center items-center">
					<MapMarkerNewForm onClose={cancelAdding} onAdd={finishAdding} />
				</div>
			)}
			<Button onClick={() => addNewItem()} type="primary">
				<div className="flex items-center gap-2">
					<PlusOutlined />
					<p>Pievienot jaunu</p>
				</div>
			</Button>
		</div>
	);
};
